// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607170312/js/" + chunkId + "." + {"44":"3249298f","225":"6c29ed45","481":"accee196","486":"3f6f7ab8","770":"42f560f9"}[chunkId] + ".0.6657539054343391.chunk.js";
};